<div class="modal-header">
  <h5 class="modal-title d-flex align-items-center gap-2">
    <fa-icon [icon]="getCreditTypeIcon()" class="text-primary"></fa-icon>
    Purchase {{ getCreditTypeLabel() }} Credits
  </h5>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="close()"
  ></button>
</div>

<div class="modal-body">
  @if (bundles().length === 0) {
    <div class="text-center py-4">
      <p class="text-muted">No credit bundles available.</p>
    </div>
  } @else {
    <p class="text-muted mb-3">
      Select a credit bundle to purchase.
    </p>

    <div class="bundle-grid">
      @for (bundle of bundles(); track bundle.priceId) {
        <div
          class="bundle-card p-3 rounded border"
          [class.selected]="selectedBundle()?.priceId === bundle.priceId"
          (click)="selectBundle(bundle)"
        >
          <div class="bundle-credits fw-bold fs-4">
            {{ bundle.credits }}
          </div>
          <div class="bundle-label text-muted small">
            {{ getCreditTypeLabel() }} Credits
          </div>
          <div class="bundle-price mt-2 fw-semibold text-primary">
            {{ formatPrice(bundle) }}
          </div>
          <div class="bundle-unit text-muted small">
            {{ formatPricePerCredit(bundle) }} / credit
          </div>
        </div>
      }
    </div>

    @if (error()) {
      <div class="alert alert-danger mt-3 mb-0">
        {{ error() }}
      </div>
    }
  }
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="close()">
    Cancel
  </button>
  <button
    type="button"
    class="btn btn-primary"
    [disabled]="!selectedBundle() || purchasing()"
    (click)="purchase()"
  >
    @if (purchasing()) {
      <fa-icon [icon]="spinnerIcon" class="fa-spin me-2"></fa-icon>
      Processing...
    } @else {
      <fa-icon [icon]="coinsIcon" class="me-2"></fa-icon>
      Purchase {{ selectedBundle()?.credits || '' }} Credits
    }
  </button>
</div>
